<template lang="pug">
  .labeled-input.pl-3(:class="{ 'labeled-input--error': error }")
    label.labeled-input__label.o-label.pr-2 {{ label }}
    input.labeled-input__input.o-input(
      v-bind="$attrs",
      @input="update",
      :value="value",
      @focus="focus(true)",
      @blur="focus(false)",
    )
</template>

<script>
  export default {
    props: {
      value: { type: String, required: false },
      label: { type: String, required: false },
      error: { type: Boolean, default: false },
    },
    data() {
      return {
        isFocused: false,
      }
    },
    methods: {
      update(event) {
        this.$emit("input", event.target.value)
      },
      focus(focus) {
        this.isFocused = focus
      },
    },
  }
</script>

<style src="./LabeledInput.sass" lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/components/LabeledInput/LabeledInput.vue